import { render, staticRenderFns } from "./CrmIntigrationList.vue?vue&type=template&id=1f40b694&scoped=true&"
import script from "./CrmIntigrationList.vue?vue&type=script&lang=js&"
export * from "./CrmIntigrationList.vue?vue&type=script&lang=js&"
import style0 from "./CrmIntigrationList.vue?vue&type=style&index=0&id=1f40b694&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f40b694",
  null
  
)

export default component.exports